var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("ContentLayout", {
    attrs: {
      title: _vm.$t("label_essweb_ClaimBalance_list_title"),
      pad: "0",
      addBtn: false,
      filterable: "",
      exportBtn:
        _vm.selectOneStaff &&
        _vm.hasBtn("export-admin-claim-transaction") &&
        _vm.curTab == "tab-2",
      importBtn: _vm.hasBtn("import-admin-claim-transaction"),
      "import-options": {
        api: "/claim-transaction-record/import/",
        templateUrl:
          "https://assets.essencehr.io/web/ess-business/assets/claim-transaction-record-import-template.xlsx",
        success: function (result) {
          _vm.selectOneStaff = null
        },
      },
    },
    on: {
      new: function ($event) {
        _vm.showNewTran = true
      },
      filter: function (val) {
        _vm.filterPageData = val
      },
      export: _vm.onExport,
    },
    scopedSlots: _vm._u([
      {
        key: "top-selection",
        fn: function (ref) {
          var filter = ref.filter
          return [
            _c("Selections2", {
              attrs: { objects: _vm.filterObjects, "small-chip": "" },
              on: {
                filter: function ($event) {
                  filter()
                  _vm.toFilter(filter)
                },
                update: function (prop, value, selected) {
                  if (prop == "department") {
                    _vm.curDept = value
                  } //触发岗位更新下拉
                  _vm.$fliterValue(_vm.filterObjects, prop, value, selected)
                },
                reset: function (apply) {
                  _vm.$fliterValue(_vm.filterObjects, null, null)
                  if (apply) {
                    filter()
                    _vm.toFilter(filter)
                  }
                },
              },
            }),
          ]
        },
      },
      {
        key: "page-main",
        fn: function () {
          return [
            _c(
              "v-card",
              {
                staticClass: "transparent d-flex flex-row rounded-lg",
                attrs: { elevation: "0" },
              },
              [
                _c(
                  "v-card",
                  {
                    staticClass: "fill-height white rounded-lg pa-0",
                    style: {
                      minHeight:
                        _vm.$vuetify.breakpoint.height - 238 + 42 - 48 + "px",
                    },
                    attrs: { elevation: "0", width: "280" },
                  },
                  [
                    _c("v-divider"),
                    _vm.show_Staff.length == 0 && !_vm.staff_Loading
                      ? _c("noContent")
                      : _vm._e(),
                    _vm.staff_Loading
                      ? _c(
                          "v-sheet",
                          {
                            staticClass:
                              "text-center d-flex align-center justify-center",
                            style: {
                              minHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                          },
                          [
                            _c("v-progress-circular", {
                              attrs: {
                                indeterminate: "",
                                color: "primary",
                                size: "30",
                                width: "2",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    !_vm.staff_Loading
                      ? _c(
                          "v-list",
                          {
                            staticClass: "scroll_content_y",
                            style: {
                              maxHeight:
                                _vm.$vuetify.breakpoint.height -
                                238 +
                                42 -
                                48 +
                                "px",
                            },
                            attrs: { dense: "" },
                          },
                          [
                            _c(
                              "v-list-item-group",
                              {
                                attrs: { color: "primary" },
                                model: {
                                  value: _vm.selectOneStaff,
                                  callback: function ($$v) {
                                    _vm.selectOneStaff = $$v
                                  },
                                  expression: "selectOneStaff",
                                },
                              },
                              _vm._l(_vm.show_Staff, function (staff, index) {
                                return _c(
                                  "v-list-item",
                                  {
                                    key: "staff---" + index,
                                    staticClass: "pa-0 px-2 ma-0",
                                    attrs: {
                                      dense: "",
                                      "two-line": "",
                                      value: staff.staff_id,
                                    },
                                  },
                                  [
                                    _c(
                                      "v-list-item-avatar",
                                      {
                                        staticClass: "pa-0 ma-0 mr-2",
                                        attrs: { size: "36" },
                                      },
                                      [
                                        _c("StaffAvatar", {
                                          attrs: {
                                            size: "36",
                                            src: staff.staff_avatar,
                                            staff_name: staff.preferred_name,
                                          },
                                        }),
                                      ],
                                      1
                                    ),
                                    _c(
                                      "v-list-item-content",
                                      [
                                        _c(
                                          "v-list-item-title",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.preferred_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "text--secondary text-caption-xs",
                                              },
                                              [_vm._v(_vm._s(staff.staff_code))]
                                            ),
                                          ]
                                        ),
                                        _c(
                                          "v-list-item-subtitle",
                                          { staticClass: "text-body-2" },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    staff.job_post_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                )
                              }),
                              1
                            ),
                          ],
                          1
                        )
                      : _vm._e(),
                  ],
                  1
                ),
                _c(
                  "v-card",
                  {
                    staticClass: "ml-3 rounded-lg flex-grow-1",
                    style: {
                      maxWidth: "calc(100% - 292px)",
                    },
                    attrs: { elevation: "0" },
                  },
                  [
                    _c("Taber", {
                      attrs: {
                        special: "",
                        backgroundColor: "white",
                        curTab: _vm.curTab,
                        items: _vm.taber,
                      },
                      on: {
                        change: function (tab) {
                          return (_vm.curTab = tab)
                        },
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "content-1",
                          fn: function () {
                            return [
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.BalanceHeaders,
                                  items: _vm.BalanceDeserts,
                                  height:
                                    _vm.$vuetify.breakpoint.height -
                                    335 -
                                    48 +
                                    16,
                                  totalCount: _vm.totalCount1,
                                  "content-class": "px-4 py-0",
                                  type: "claimbalance",
                                },
                                on: {
                                  change: function (page, perpage, callback) {
                                    _vm.getDetail(
                                      _vm.selectOneStaff,
                                      page,
                                      perpage,
                                      callback
                                    )
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.claim_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.claim_brought_forward",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table-title text--primary",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  item.claim_brought_forward
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.claim_earned",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table-title text--primary",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.claim_earned) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.claim_entitlement",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table-title text--primary",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.claim_entitlement) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.claim_taken",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "table-title text--primary",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.claim_taken) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.currency",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.currency_code) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.balance",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  parseFloat(
                                                    Number(item.claim_balance)
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.pending",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  parseFloat(
                                                    Number(item.claim_pending)
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.f_balance",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  parseFloat(
                                                    Number(
                                                      item.claim_future_balance
                                                    )
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.action",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return undefined
                                    },
                                  },
                                ]),
                              }),
                            ]
                          },
                          proxy: true,
                        },
                        {
                          key: "content-2",
                          fn: function () {
                            return [
                              _vm.selectOneStaff
                                ? _c(
                                    "v-sheet",
                                    {
                                      staticClass:
                                        "d-flex justify-end px-4 mb-n4",
                                    },
                                    [
                                      _vm.hasBtn("add-admin-claim-transaction")
                                        ? _c(
                                            "v-btn",
                                            {
                                              staticClass: "text-capitalize",
                                              attrs: {
                                                text: "",
                                                color: "primary",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showNewTran = true
                                                },
                                              },
                                            },
                                            [
                                              _vm._v(
                                                " " +
                                                  _vm._s(
                                                    _vm.$t(
                                                      "label_essweb_ClaimBalance_form_dialog_addClaimTypeBtnLabel"
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "material-icons-round",
                                                },
                                                [_vm._v("add")]
                                              ),
                                            ]
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("Tabler", {
                                attrs: {
                                  headers: _vm.TransactionHeaders,
                                  items: _vm.TransactionDeserts,
                                  height:
                                    _vm.$vuetify.breakpoint.height -
                                    335 -
                                    48 -
                                    24,
                                  type: "claimbalance",
                                  totalCount: _vm.totalCount2,
                                },
                                on: {
                                  change: function (page, perpage, callback) {
                                    _vm.getTransaction(
                                      _vm.selectOneStaff,
                                      page,
                                      perpage,
                                      callback
                                    )
                                  },
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.swift_id",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.swift_number) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.claim_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.tr_type",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  _vm.$getCommonLangValue(
                                                    item.claim_transaction_type_name
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.currency",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.currency_code) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.amount",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(
                                                  parseFloat(
                                                    Number(item.total_amount)
                                                  )
                                                ) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.period",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "text--primary table-title",
                                          },
                                          [
                                            _vm._v(
                                              " " +
                                                _vm._s(item.claim_period) +
                                                " "
                                            ),
                                          ]
                                        ),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.status",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _c("StatusChip", {
                                          attrs: {
                                            slideColor:
                                              item.status_value == "1"
                                                ? "orange"
                                                : item.status_value == "2" ||
                                                  item.status_value == "3" ||
                                                  item.status_value == "4"
                                                ? "grey"
                                                : item.status_value == "0" ||
                                                  item.status_value == "5" ||
                                                  item.status_value == "6"
                                                ? "green"
                                                : "currentColor",
                                          },
                                          scopedSlots: _vm._u(
                                            [
                                              {
                                                key: "status",
                                                fn: function () {
                                                  return [
                                                    _vm._v(
                                                      " " +
                                                        _vm._s(
                                                          _vm.$getCommonLangValue(
                                                            item.status_name
                                                          )
                                                        ) +
                                                        " "
                                                    ),
                                                  ]
                                                },
                                                proxy: true,
                                              },
                                            ],
                                            null,
                                            true
                                          ),
                                        }),
                                      ]
                                    },
                                  },
                                  {
                                    key: "item.action",
                                    fn: function (ref) {
                                      var item = ref.item
                                      return [
                                        _vm.hasBtn("view-admin-claim-balance")
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: { small: "", icon: "" },
                                                on: {
                                                  click: function ($event) {
                                                    _vm.detailUuid = item.uuid
                                                    _vm.showViewTran = true
                                                  },
                                                },
                                              },
                                              [
                                                _c("svg-icon", {
                                                  attrs: {
                                                    size: "24",
                                                    fill: "currentColor",
                                                    iconClass: "viewDetail",
                                                  },
                                                }),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ]),
                              }),
                            ]
                          },
                          proxy: true,
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]
        },
        proxy: true,
      },
      {
        key: "tools-main",
        fn: function () {
          return [
            _c("newTransactions", {
              attrs: {
                show: _vm.showNewTran,
                staff_uuid: _vm.selectOneStaff,
                curUuid: _vm.selectOneStaff,
              },
              on: {
                close: function ($event) {
                  _vm.showNewTran = false
                },
                onNew: _vm.onNewTransaction,
              },
            }),
            _c("viewTransactions", {
              attrs: {
                show: _vm.showViewTran,
                staff_uuid: _vm.selectOneStaff,
                curUuid: _vm.selectOneStaff,
                detailUuid: _vm.detailUuid,
              },
              on: {
                close: function ($event) {
                  _vm.showViewTran = false
                  _vm.detailUuid = null
                },
              },
            }),
          ]
        },
        proxy: true,
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }